<template>
  <div class="row">
    <!--   Company Information -->
    <div class="col-xl-6">
      <company_information
          :ifNotCompanyContactUser="ifNotCompanyContactUser"
          :company="company"
          :isPayrollCrm="isPayrollCrm"
          :payment_process_info="payment_process_info"
      ></company_information>
    </div>
    <!-- Company Rebate -->
    <div v-if="isCompanyLiveActive && ifNotCompanyContactUser" class="col-xl-6">
      <company_rebate
          :referral_rebate="referral_rebate"
          :isAdminManagerUser="isAdminManagerUser"
          :company="company"
      ></company_rebate>
    </div>
    <!-- Payment Information/Process -->
    <div class="col-12" v-if="show_new_invoice_template_selection === 'true'">
      <new_payment_process_information
          :ifNotCompanyContactUser="ifNotCompanyContactUser"
          :payment_process_info="payment_process_info"
          :isPayrollCrm="isPayrollCrm"
          :isRecruitmentCrm="isRecruitmentCrm"
          :returnCrmCompanyName="returnCrmCompanyName"
          :company="company"
      ></new_payment_process_information>
    </div>
    <div class="col-12" v-else>
      <payment_process_information
          :ifNotCompanyContactUser="ifNotCompanyContactUser"
          :payment_process_info="payment_process_info"
          :isPayrollCrm="isPayrollCrm"
          :isRecruitmentCrm="isRecruitmentCrm"
          :returnCrmCompanyName="returnCrmCompanyName"
          :company="company"
      ></payment_process_information>
    </div>

    <!-- Retention percentage -->
    <div class="col-12">
      <company_retention_percentage
        :company="company"
      ></company_retention_percentage>
    </div>  

    <!-- Absence required -->
    <div class="col-12">
      <worker_absence_required
        :company="company"
      ></worker_absence_required>
    </div>

    <!-- Worker Show Company -->
    <div class="col-12">
      <worker_show_company
        :company="company"
      ></worker_show_company>
    </div>

    <!-- Charges -->
    <div class="col-12">
      <charges
          :ifNotCompanyContactUser="ifNotCompanyContactUser"
          :isPayrollCrm="isPayrollCrm"
          :payment_process_info="payment_process_info"
          :company="company"
      ></charges>
    </div>
    <!-- Company Payment Groups (and texts) -->
    <div class="col-12">
      <pay_groups
          :isPayrollCrm="isPayrollCrm"
          :isRecruitmentCrm="isRecruitmentCrm"
          :pay_groups="company.rel_company_pay_groups"
          :company="company"
      ></pay_groups>
    </div>
    <!-- Partnership between V3 & GM -->
    <div class="col-12">
      <partnership
          :ifNotCompanyContactUser="ifNotCompanyContactUser"
          :isRecruitmentCrm="isRecruitmentCrm"
          :isPayrollCrm="isPayrollCrm"
          :company="company"
      ></partnership>
    </div>
    <!-- Finance -->
    <div class="col-12">
      <credit_finance
          :ifNotCompanyContactUser="ifNotCompanyContactUser"
          :isPayrollCrm="isPayrollCrm"
          :isRecruitmentCrm="isRecruitmentCrm"
          :credit_finance="credit_finance"
          :company="company"
      ></credit_finance>
    </div>
    <!-- Client Referrals -->
    <div v-if="isCompanyLiveActive" class="col-12">
     <company_referrals
         :referral_rebate="referral_rebate"
         :isAdminManagerUser="isAdminManagerUser"
         :company="company"
     ></company_referrals>
    </div>
  </div>
</template>
<script>
// template component templates
import company_information from "pages/companies/record/finance/company_information";
import company_rebate from "pages/companies/record/finance/company_rebate";
import payment_process_information from "pages/companies/record/finance/payment_process_information";
import new_payment_process_information from "pages/companies/record/finance/new_payment_process_information";
import charges from "pages/companies/record/finance/charges";
import pay_groups from "pages/companies/record/finance/pay_groups";
import partnership from "pages/companies/record/finance/partnership";
import credit_finance from "pages/companies/record/finance/credit_finance";
import company_referrals from "pages/companies/record/finance/company_referrals";
import company_retention_percentage from "./finance/company_retention_percentage.vue";
import worker_absence_required from "./finance/worker_absence_required.vue";
import worker_show_company from "./finance/worker_show_company_name.vue";

export default {
  name: "accounts_payment",
  props: ['company', 'payment_process_info', 'referral_rebate', 'credit_finance'],
  components: {
    company_information,
    company_rebate,
    payment_process_information,
    new_payment_process_information,
    charges,
    pay_groups,
    partnership,
    credit_finance,
    company_referrals,
    company_retention_percentage,
    worker_absence_required,
    worker_show_company
},
  data() {
    return {
      show_new_invoice_template_selection: process.env.MIX_SHOW_NEW_INVOICE_TEMPLATE_SELECTION,
      // ms_opts: {
      //   pay_worker_payment_day: daysOfWeek,
      //   pay_worker_payment_time: hoursOfDay,
      //   pay_worker_text_day: daysOfWeek,
      // }
    }
  },
  computed: {
    ifNotCompanyContactUser() {
      return !this.$store.state.auth.me.roles.includes('client_sub') && !this.$store.state.auth.me.roles.includes('client_auth')
    },
    isAdminManagerUser() {
      return this.$store.state.auth.me.roles.includes('admin') || this.$store.state.auth.me.roles.includes('manager')
    },
    isCompanyLiveActive() {
      return this.company.company_type === 'Active' || this.company.company_type === 'Live'
    },
    isPayrollCrm() {
      return this.crmType === 'payroll'
    },
    isRecruitmentCrm() {
      return this.crmType === 'recruitment'
    },
    returnCrmCompanyName() {
      if (this.isPayrollCrm) {
        return "Genius"
      }
      else if (this.isRecruitmentCrm) {
        return "V3"
      }
      else return ""
    },
  },
  methods: {
    check_referrals() {
      // if (!this.notEmptyObject(this.referral_rebate)) {
      //   this.edit_referrals = Object.assign({}, {
      //     rebate: {
      //       company_id: this.company.id,
      //       referred_company_id: this.company.id,
      //       amount_per_payrolled_worker: '',
      //       referral_start_date: null,
      //       referral_end_date: null,
      //
      //       log_by_type: 'App\\Models\\Users\\User',
      //       log_by_id: this.$store.state.auth.me.id
      //     },
      //     referrals: {
      //       company_id: this.company.id,
      //       referred_company_id: '',
      //       referred_client: null,
      //       amount_per_payrolled_worker: '',
      //       referral_start_date: null,
      //       referral_end_date: null,
      //
      //       log_by_type: 'App\\Models\\Users\\User',
      //       log_by_id: this.$store.state.auth.me.id
      //     }
      //   })
      // }
      // else {
      //   if (!this.notEmptyObject(this.referral_rebate.rebate)) {
      //     this.edit_referrals.rebate = Object.assign({}, {
      //       company_id: this.company.id,
      //       referred_company_id: this.company.id,
      //       amount_per_payrolled_worker: '',
      //       referral_start_date: null,
      //       referral_end_date: null,
      //
      //       log_by_type: 'App\\Models\\Users\\User',
      //       log_by_id: this.$store.state.auth.me.id
      //     })
      //   }
      //   else {
      //     this.edit_referrals.rebate = Object.assign({}, this.referral_rebate.rebate);
      //   }
      //   if (!this.notEmptyObject(this.referral_rebate.referrals)) {
      //     this.edit_referrals.referrals = Object.assign({}, {
      //       company_id: this.company.id,
      //       referred_company_id: '',
      //       referred_client: null,
      //       amount_per_payrolled_worker: '',
      //       referral_start_date: null,
      //       referral_end_date: null,
      //
      //       log_by_type: 'App\\Models\\Users\\User',
      //       log_by_id: this.$store.state.auth.me.id
      //     })
      //   }
      //   else {
      //     this.edit_referrals.referrals = Object.assign({}, this.referral_rebate.referrals);
      //   }
      // }
    },
  }
}
</script>
